/**
 * Plugin that subscribes to the `slideAttributes/updateAttributes` mutation and
 * invalidates the cached slide-attributes bootstrap for the affected slide.
 *
 * `getSlideAttributesWithCacheAction` caches each slide's attributes for
 * SLIDE_ATTRIBUTES_CACHE_MAX_AGE_SECONDS (60s). Local writes purge their key
 * inline, but attribute changes that arrive over live sync (MQTT kvSync) — a
 * cross-client edit, or a plugin that persists via its own iframe request
 * rather than upsertSlideAttributeAction — only commit `updateAttributes`.
 * Without this purge the next mount of that slide could serve pre-change data
 * for up to the full TTL. Mirrors skip-slide.plugin.js, which subscribes to the
 * same mutation.
 */
const slideAttributesCachePurgePlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type !== 'slideAttributes/updateAttributes') return

    const slideId = mutation.payload?.slideId
    if (slideId == null) return

    store.dispatch('purgeSlideAttributesCacheAction', slideId)
  })
}

export default slideAttributesCachePurgePlugin
